<!-- 地区销售排行  
柱状图 动态 柱子采用队列形式 每刷新一次 进出一根柱子
-->

<template>
	<div class="com-container">
		<div class="com-chart" ref="trend_ref"></div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				chartInstance: null, // echart实例对象
				// allData: null, // 从服务器中获取的所有数据
				startValue: 0, // 区域缩放的起点值
				endValue: 9, // 区域缩放的终点值
				timerId: null, // 定时器的标识
				allData: [{
						"name": "广东",
						"value": 230
					},
					{
						"name": "福建",
						"value": 214
					},
					{
						"name": "浙江",
						"value": 203
					},
					{
						"name": "上海",
						"value": 310
					},
					{
						"name": "北京",
						"value": 289
					},
					{
						"name": "江苏",
						"value": 207
					},
					{
						"name": "四川",
						"value": 189
					},
					{
						"name": "重庆",
						"value": 195
					},
					{
						"name": "陕西",
						"value": 160
					},
					{
						"name": "湖南",
						"value": 140
					},
					{
						"name": "河北",
						"value": 170
					},
					{
						"name": "辽宁",
						"value": 106
					},
					{
						"name": "湖北",
						"value": 120
					},
					{
						"name": "江西",
						"value": 99
					},
					{
						"name": "天津",
						"value": 107
					},
					{
						"name": "吉林",
						"value": 143
					},
					{
						"name": "青海",
						"value": 65
					},
					{
						"name": "山东",
						"value": 166
					},
					{
						"name": "山西",
						"value": 134
					},
					{
						"name": "云南",
						"value": 87
					},
					{
						"name": "安徽",
						"value": 79
					}
				],

			}
		},
		mounted() {
			this.initChart()
			this.getData()
			window.addEventListener('resize', this.screenAdapter) // 分辨率的适配
			this.screenAdapter() // 主动调一次各种尺寸的计算
		},
		destroyed() {
			window.removeEventListener('resize', this.screenAdapter) // 取消监听
			clearInterval(this.timerId)
		},
		methods: {
			initChart() { // 初始化实例对象的方法
				this.chartInstance = this.echarts.init(this.$refs.trend_ref, 'chalk')
				const initOption = {
					title: {
						text: '▎ 地区销售排行',
						left: 20,
						top: 20
					},
					grid: {
						top: '40%',
						left: '5%',
						right: '5%',
						bottom: '5%',
						containLabel: true
					},
					tooltip: {
						show: true
					},
					xAxis: {
						type: 'category' // X轴是类目轴
					},
					yAxis: {
						type: 'value' // y轴是数据轴
					},
					series: [{ // 是个数组
						type: 'bar' // 图形是柱状图
					}]
				}
				this.chartInstance.setOption(initOption)
				this.chartInstance.on('mouseover', () => { // 鼠标移入时 清除定时器，图表就不会动了
					clearInterval(this.timerId)
				})
				this.chartInstance.on('mouseout', () => { // 鼠标移走时 开始定时器，图表又开始向左平移了
					this.startInterval()
				})
			},
			getData() {
				// 对allData 对象数组 里面的每一个元素进行排序, 从大到小进行
				this.allData.sort((a, b) => {
					return b.value - a.value
				})

				this.updateChart() // 更新图表
				this.startInterval() // 获取数据之后启动定时器

			},
			updateChart() { //处理数据  更新数据
				// 二维数组 三段数值，每一段的两个值分别代表渐变颜色的开始值与结束值
				const colorArr = [
					['#0BA82C', '#4FF778'],
					['#2E72BF', '#23E5E5'],
					['#5052EE', '#AB6EE5']
				]
				//数据处理：通过 对象数组 this.allData 生成两个数组：一个是省份名称数组、 另一个每个省份的销售金额数据
				// 所有省份所形成的数组
				const provinceArr = this.allData.map(item => {
					return item.name
				})
				// 所有省份对应的销售金额
				const valueArr = this.allData.map(item => {
					return item.value
				})

				const dataOption = {
					xAxis: {
						data: provinceArr
					},
					dataZoom: { // 数据的区域缩放 
						show: false, // true 区域缩放控件会出现
						startValue: this.startValue, // 通过dataZoom 实现一次性展现10个柱子
						endValue: this.endValue
					},
					series: [{
						data: valueArr,
						itemStyle: {
							color: arg => { // color支撑回调函数 arg.value 柱状图的数值
								// 不同的数值段，显示不同的颜色
								let targetColorArr = null
								if (arg.value > 300) {
									targetColorArr = colorArr[0]
								} else if (arg.value > 200) {
									targetColorArr = colorArr[1]
								} else {
									targetColorArr = colorArr[2]
								}
								return new this.echarts.graphic.LinearGradient(0, 0, 0, 1, [{
										offset: 0,
										color: targetColorArr[0]
									},
									{
										offset: 1,
										color: targetColorArr[1]
									}
								])
							}
						}
					}]
				}
				this.chartInstance.setOption(dataOption)
			},
			screenAdapter() { // 1.标题的文字大小   2. 柱的宽度  3.柱的圆角
				const titleFontSize = this.$refs.trend_ref.offsetWidth / 100 * 3.6
				const adapterOption = {
					title: { // 标题的文字大小
						textStyle: {
							fontSize: titleFontSize
						}
					},
					series: [{
						barWidth: titleFontSize, //柱的宽度
						itemStyle: {  // 柱的圆角
							barBorderRadius: [titleFontSize / 2, titleFontSize / 2, 0, 0]  // 左上  右上  右下  左下
						}
					}]
				}
				this.chartInstance.setOption(adapterOption)
				this.chartInstance.resize()
			},
			startInterval() { // 让圆柱每隔2秒向左平移，新的柱子在右边生成    定时器的启动时机： 1. 获取数据后启动   2.鼠标移走后启动       定期器停止:  1.组件销毁时停止   2. 鼠标移入时停止
				if (this.timerId) { // 启动定时器前，先清空定时器
					clearInterval(this.timerId)
				}
				this.timerId = setInterval(() => {
					this.startValue++
					this.endValue++
					if (this.endValue > this.allData.length - 1) { // 平移到最后一个，从头开始
						this.startValue = 0
						this.endValue = 9
					}
					this.updateChart()
				}, 2000)
			},


		}
	}
</script>

<style>
</style>
